import { TimeSpan } from "@/Common/Models/TimeSpan";

interface ITimerSlaveProps {

    getValue: () => TimeSpan;
    format: string;
    resetId: string;
}

class TimerSlaveState {
    public value: TimeSpan;
}

class TimerComponent_SlaveLongPool extends React.Component<ITimerSlaveProps, TimerSlaveState> {
    private intervalId;

    public componentWillMount(): void {
        let self = this;

        self.mutateState(s => s.value = self.props.getValue());
    }

    public componentDidMount(): void {
        let self = this;
        self.intervalId = window.setInterval(() => {
            self.mutateState(s => s.value = self.props.getValue());
        }, 1000);
    }

    public componentWillReceiveProps(nextProps: ITimerSlaveProps): void {
        let self = this;
        if (this.props.resetId != nextProps.resetId)
            self.mutateState(s => s.value = nextProps.getValue());
    }

    public componentWillUnmount(): void {
        clearInterval(this.intervalId);
    }

    public render(): JSX.Element {
        let time = this.state.value == null ? "" : this.state.value.toString(this.props.format);

        return (
            <div>
                <span>{time}</span>
            </div>
        );
    }

    private mutateState(mutation: (s: TimerSlaveState) => void, then: () => void = null): void {
        var s = new TimerSlaveState();
        mutation(s);
        this.setState(s, then);
    }
}

export { TimerComponent_SlaveLongPool };
